<!-- 公共级联选择 -->
<template>
    <div class="PublicMultipleSelect" ref="MultipleSelect" :style="{'z-index': otherParam.hierarchy || 1 }" :title="pitchOnFile.name">
      <el-select
        v-model="pitchOnFile.name"
        :disabled="disabled"
        :popper-append-to-body="AppendBody"
        v-scroll="bindScroll"
        popper-class="file-search-select"
        filterable
        reserve-keyword
         remote
        :remote-method="TriggerSearch"
        :placeholder="$t(`lang.${otherParam.placeholder}`)"
        @change="fileSelectChange"
        @focus="GetFocusData"
        @visible-change="SelectShow"
        @clear="clearMessage"
        :loading="FirstLoading"
        :clearable="true"
        ref="changeTab"
        >
        <div class="IsSearchList" v-show="IsSearchList">
          <el-option
            v-for="item in SearchSelectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
            <span class="videoLeft" style="float: left;overflow: hidden;text-overflow: ellipsis;" :style="{width: (SelectType == 2 && item.videoTimes == undefined) ? '98%' : '70%'}" :title="item.name">{{$t(`lang.${getSelectType(SelectType == 2 ? item.category :item.type)}`)}}/{{ item.name }}</span>
            <span class="videoRight" style="float: right;width: 30%;overflow: hidden;text-overflow: ellipsis;" :title="formatSeconds(SelectType == 2 ? item.videoTimes : item.duration)">{{formatSeconds(SelectType == 2 ? item.videoTimes : item.duration)}}</span>
          </el-option>
        </div>
      </el-select>
      <div class="CascaderPanel">
        <el-cascader-panel
        ref="cascaderPanel"
        v-if="!IsSearchList"
        :props="props"
        @expand-change="SwitchingTab"
        @change="cascaderChange"
        >
        <template slot-scope="{ node, data }">
          <div v-if="node.isLeaf">
            <span class="videoLeft" style="float: left;overflow: hidden;text-overflow: ellipsis;" :style="{width: data.duration == undefined ? '98%' : '70%'}" :title="data.label">{{ data.label }}</span>
            <span class="videoRight" v-if="node.isLeaf && data.duration != undefined" style="float: right;width: 30%;overflow: hidden;text-overflow: ellipsis;" :title="formatSeconds(data.duration)">{{formatSeconds(data.duration)}}</span>
          </div>
          <span class="videoLeft" v-else style="float: left;width: 90%;overflow: hidden;text-overflow: ellipsis;" :title="data.label">{{ $t(`lang.${data.label}`) }}</span>
        </template>
        </el-cascader-panel>
      </div>
    </div>
</template>

<script>
import toTips from '@/assets/js/toTipsObj'
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    SelectType: {
      type: Number,
      default: 1 // 1普通  2MediaLive
    },
    //   选择的参数
    SelectValue: {
      type: Object,
      default: () => ({
        fileId: '',
        fileName: ''
      })
    },
    // 配置
    configParams: {
      type: Object,
      default: () => ({
        List: {
          Media: {
            url: '/scteUnderplay/pageUnderPlay',
            Params: {
              pageNum: 0,
              pageSize: 10,
              totalNum: 1,
              bucketCode: '',
              userId: '',
              type: 1
            },
            List: []
          },
          programTemplate: {
            url: '/scteUnderplay/pageUnderPlay',
            Params: {
              pageNum: 0,
              pageSize: 10,
              totalNum: 1,
              bucketCode: '',
              userId: '',
              type: 2
            },
            List: []
          }
        },
        search: {
          url: '/scteUnderplay/pageUnderPlay',
          Params: {
            pageNum: 0,
            pageSize: 10,
            totalNum: 1,
            condition: '',
            bucketCode: '',
            userId: '',
            type: 0
          }
        }
      })
    },
    // 搜索类型
    SearchTypeList: {
      type: Array,
      default: () => []
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否将弹出框插入至 body 元素,在弹出框的定位出现问题时，可将该属性设置为 false
    AppendBody: {
      type: Boolean,
      default: false
    },
    // 其他参数
    otherParam: {
      type: Object,
      default: () => ({
        placeholder: 'select', // 提示
        hierarchy: 1
      })
    }
  },
  data () {
    return {
      // 选择的zhi
      pitchOnFile: {
        id: '',
        name: ''
      },
      // 所有节点
      AllNode: {},
      // 多类组件配置
      props: {
        lazy: true,
        lazyLoad: this.lazyLoad
      },
      // 搜索传参
      SearchParams: {
      },
      // 搜索选择滚动加载
      bindScroll: {
        onScroll: this.SearchList,
        directive: '.el-select-dropdown__list',
        distance: 50
      },
      // 搜索列表
      SearchSelectList: [],
      // 是否在搜索
      IsSearchList: true,
      // 加载
      FirstLoading: false,
      // 是否绑定滚动加载
      BindScroll: {
        IsBindScroll: false,
        BindType: ''
      },
      // 第一级分类
      TypeSelect: [],
      // 列表配置
      ListConfig: {},
      // mediaLive顺序
      MediaLiveOrder: ['Live', 'Media', 'AmazonS3']
    }
  },
  watch: {
    // 监听外部传的值是否变化
    SelectValue (item) {
      this.FileEcho()
    },
    configParams () {
      this.ConfigInit()
    }
  },
  computed: {
    // 获取选择类型
    getSelectType () {
      return (type) => {
        let TypeSelect = ''
        if (this.SelectType == 1) {
          const ShowType = this.TypeSelect.filter(item => item.type == type)
          if (ShowType[0]) {
            TypeSelect = ShowType[0].label
          }
        } else {
          TypeSelect = this.MediaLiveOrder[type - 1]
        }
        return TypeSelect
      }
    }
  },
  created () {
    this.ConfigInit()
    this.FileEcho()
  },
  mounted () {
    document.addEventListener('visibilitychange', this.getPageHide)
    document.addEventListener('click', this.clickEvent, true)
  },
  methods: {
    // 配置初始化
    ConfigInit () {
      this.TypeSelect = []
      let index = 0
      const List = this.configParams.List
      Object.keys(List).forEach((key) => {
        this.TypeSelect.push({
          value: index,
          label: key,
          leaf: false,
          type: List[key]?.Params?.type
        })
        index++
      })
      this.ListConfig = JSON.parse(JSON.stringify(this.configParams.List))
      this.SearchParams = JSON.parse(JSON.stringify(this.configParams.search.Params))
      this.SearchParams.searchType = JSON.parse(JSON.stringify(this.SearchTypeList))
    },
    // 文件回显
    FileEcho () {
      if (this.SelectValue.fileName) {
        this.pitchOnFile = {
          id: this.SelectValue.fileId,
          name: this.SelectValue.fileName
        }
      } else if (this.SelectValue.fileId) {
        this.pitchOnFile = {
          id: this.SelectValue.fileId,
          name: this.SelectValue.fileId
        }
      } else {
        this.pitchOnFile = {
          id: '',
          name: ''
        }
      }
    },
    // 获取焦点
    GetFocusData () {
      const selectDom = this.$refs.MultipleSelect
      const elDom = selectDom.querySelectorAll('.el-select-dropdown')
      if (elDom && elDom[0] && elDom[0].style.display == 'none') {
        this.ClearSearch()
        this.IsSearchList = false
      }
    },
    // 清楚数据
    clearMessage () {
      this.$emit('clearMessage')
    },
    // 搜索选则完
    fileSelectChange (key) {
      const SelectMessage = this.SearchSelectList.filter(
        (item) => item.id === key
      )
      if (SelectMessage.length < 1) return
      this.pitchOnFile.id = SelectMessage[0].id
      this.pitchOnFile.name = SelectMessage[0].name
      this.ClearSearch()
      this.$emit('MediaLiveSelectChange', {
        Select: 'search',
        ...SelectMessage[0]
      })
    },
    // 分类选择完
    cascaderChange (value) {
      const type = this.TypeSelect[value[0]].label
      let SelectData = {}
      this.ListConfig[type].List.forEach((item) => {
        if (item.id == value[1]) {
          SelectData = JSON.parse(JSON.stringify(item))
          this.pitchOnFile.id = item.id
          this.pitchOnFile.name = item.name
        }
      })
      this.IsSearchList = true
      this.ClearListData()
      this.$emit('MediaLiveSelectChange', {
        Select: type,
        ...SelectData
      })
    },
    // 切换页面回来隐藏选择
    getPageHide (e) {
      if (e.target.visibilityState == 'visible') {
        this.$refs.changeTab.blur()
        this.IsSearchList = true
        this.ClearListData()
      }
    },
    // 确保搜索收起下拉，内容清空
    SelectShow (key) {
      if (!key) {
        this.$refs.changeTab.blur()
      }
    },
    // 点击触发加载数据
    lazyLoad (node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        const nodes = this.TypeSelect
        resolve(nodes)
      } else {
        this.AllNode[node.label] = {
          node,
          resolve
        }
        this.getNodeContent(node.label)
      }
    },
    // huoqu数据
    getNodeContent (type) {
      const TypeParams = this.ListConfig[type]
      if (TypeParams.Params.pageNum >= TypeParams.Params.totalNum) return
      TypeParams.Params.pageNum++
      this.axios.post(Outil.getUrl(TypeParams.url), TypeParams.Params)
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            let data = res.data.result.list
            if (!data)data = []
            const List = data.map(item => {
              const ListItem = {
                value: item.id,
                label: item.name,
                duration: this.SelectType == 2 ? item.videoTimes : item.duration,
                leaf: true
              }
              return ListItem
            })
            if (TypeParams.Params.pageNum == 1) {
              this.ListConfig[type].List = data
              TypeParams.Params.totalNum = Math.ceil(res.data.result.total / TypeParams.Params.pageSize)
            } else {
              this.ListConfig[type].List.push(...data)
            }
            const resolve = this.AllNode[type].resolve
            resolve(List)
          } else {
            TypeParams.Params.pageNum--
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch((err) => {
          TypeParams.Params.pageNum--
          console.log(err)
        })
    },
    // 触发搜索
    TriggerSearch (key) {
      if (key) {
        this.ClearSearch()
        this.SearchParams.condition = key
        this.IsSearchList = true
        this.ClearListData()
        this.SearchList()
      } else {
        this.ClearSearch()
        this.IsSearchList = false
      }
    },
    // 搜索列表
    SearchList () {
      if (this.SearchParams.pageNum >= this.SearchParams.totalNum) return
      this.SearchParams.pageNum++
      this.axios.post(Outil.getUrl(this.configParams.search.url), this.SearchParams)
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            if (this.SearchParams.pageNum == 1) {
              this.SearchSelectList = res.data.result.list
              this.SearchParams.totalNum = Math.ceil(res.data.result.total / this.SearchParams.pageSize)
            } else {
              this.SearchSelectList.push(...res.data.result.list)
            }
          } else {
            this.SearchParams.pageNum--
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch((err) => {
          this.SearchParams.pageNum--
          console.log(err)
        })
    },
    // 切换tab
    SwitchingTab (key) {
      const type = this.TypeSelect[key[0]].label
      this.BindScroll.BindType = type
      const selectDom = this.$refs.MultipleSelect
      const elDom = selectDom.querySelectorAll('.el-cascader-menu__wrap')[1]
      if (elDom) {
        elDom.scrollTop = 0
      }
      // 绑定滚动加载
      if (!this.BindScroll.IsBindScroll) {
        this.$nextTick(() => {
          this.MonitorScroll(50)
        })
      }
    },
    // 监听级联选择器滚动加载
    MonitorScroll (distance) {
      // 是否执行回调事件
      let isCallback = true
      const selectDom = this.$refs.MultipleSelect
      const elDom = selectDom.querySelectorAll('.el-cascader-menu__wrap')[1]
      elDom.onscroll = (e) => {
        // 获取当前节点可滚动的距离
        const scrollHeight = e.target.scrollHeight - e.target.clientHeight
        // 获取节点剩余可滚动的高度
        const residualHeight = scrollHeight - e.target.scrollTop
        //  滚动到指定区域执行回调事件
        if (residualHeight <= distance && isCallback) {
          // 执行事件回调函数
          this.getNodeContent(this.BindScroll.BindType)
          isCallback = false
        } else if (residualHeight > distance) {
          isCallback = true
        }
      }
    },
    // 清除列表数据
    ClearListData () {
      Object.keys(this.ListConfig).forEach((key) => {
        this.ListConfig[key].Params.pageNum = 0
        this.ListConfig[key].Params.totalNum = 1
        this.ListConfig[key].List = []
      })
    },
    // 清除搜索
    ClearSearch () {
      this.SearchSelectList = []
      this.SearchParams.condition = ''
      this.SearchParams.pageNum = 0
      this.SearchParams.totalNum = 1
    },
    formatSeconds (i) {
      return Outil.changgeformatSeconds(i, name)
    },
    // 点击组件之外地方
    clickEvent (e) {
      const event = e || window.event
      const tar = event.srcElement || event.target
      try {
        if (!this.$refs.MultipleSelect.contains(tar)) {
          if (!this.IsSearchList) {
            this.IsSearchList = true
            this.ClearListData()
          }
        }
      } catch (error) {
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.clickEvent, true)
    document.removeEventListener('visibilitychange', this.getPageHide)
  }
}
</script>

<style scoped lang="less">
.PublicMultipleSelect{
  position: relative;
  z-index: 1;
  text-align: left;
  width: 100%;
  ::v-deep .el-select{
    .el-input--suffix{
      .el-input__inner{
        background: #444;
        height: 30px;
      }
    }
    .el-select-dropdown {
      top: 40px !important;
      left: 5px !important;
    }
    .el-scrollbar__wrap{
      width: 100%;
      .el-scrollbar__view{
        width: 100%;
      }
    }
  }
  ::v-deep .CascaderPanel {
    position: absolute;
    top: 100%;
    left: 0;
    .el-cascader-menu {
      height: 214px;
      width: 100px;
      overflow: hidden;
    }
    .el-cascader-menu__list {
      height: fit-content;
    }
    .el-scrollbar__bar{
      opacity: 1;
      .el-scrollbar__thumb{
        background-color: rgba(144,147,153,.5);
      }
    }
    .el-cascader-menu__wrap::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      width: 5px;
      border-radius: 5px;
      background-color: rgb(233, 233, 233);
      opacity: 0.7;
      display: none;
    }
  }
  ::v-deep .CascaderPanel .el-cascader-menu:nth-child(1){
    min-width: 130px;
    width: 130px;
    .el-cascader-node{
      padding-right: 0px;
      padding-left: 5px;
    }
  }
  ::v-deep .CascaderPanel .el-cascader-menu:nth-child(2){
    .el-cascader-node{
      padding-right: 0px;
      padding-left: 10px;
    }
  }
}

</style>
